import { render, staticRenderFns } from "./ecosystem-switcher-modal.vue?vue&type=template&id=1a7d6510"
import script from "./ecosystem-switcher-modal.ts?vue&type=script&lang=js&external"
export * from "./ecosystem-switcher-modal.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports